module.exports = __webpack_public_path__ + "img/smc-logo.96f808c3.svg";